import { Injectable } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { CfgService } from '../../cfg/cfg.service';

export class LoggerCfg {
  application: string;
  component: string;
  environment: string;
  endpoint: string;
  activechk: number;
}

@Injectable({
  providedIn: 'root'
})
export class LoggerCfgService extends CfgService<LoggerCfg> {
  protected exclude: boolean = true;

  constructor(httpBackend: HttpBackend) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/logger.cfg.json`;
  }
}
